import { render, staticRenderFns } from "./VictoryUnits.vue?vue&type=template&id=6ac0dff5&scoped=true&lang=pug&"
import script from "./VictoryUnits.vue?vue&type=script&lang=ts&"
export * from "./VictoryUnits.vue?vue&type=script&lang=ts&"
import style0 from "./VictoryUnits.vue?vue&type=style&index=0&id=6ac0dff5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac0dff5",
  null
  
)

export default component.exports